
export default function Guarantee() {
  return (
    <section className="py-16 bg-green-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-shield-check-line text-4xl text-green-600"></i>
            </div>
            
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
              Garantia de 7 Dias
            </h2>
            
            <p className="text-xl text-gray-600 mb-6">
              Não ficou satisfeito? Devolvemos 100% do seu dinheiro!
            </p>
            
            <div className="bg-green-50 rounded-lg p-6">
              <p className="text-lg text-gray-700 leading-relaxed">
                Estamos tão confiantes na qualidade do nosso kit que oferecemos uma garantia completa. 
                Se por qualquer motivo você não ficar completamente satisfeito com sua compra, 
                <strong className="text-green-600"> devolvemos todo o seu dinheiro em até 7 dias</strong>, 
                sem perguntas e sem complicações.
              </p>
            </div>
            
            <div className="flex items-center justify-center gap-8 mt-8 text-sm text-gray-500">
              <div className="flex items-center gap-2">
                <i className="ri-check-line text-green-500"></i>
                <span>Sem Perguntas</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-check-line text-green-500"></i>
                <span>Reembolso Total</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-check-line text-green-500"></i>
                <span>Processo Rápido</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
